export const paceData = [
    {
        id: "ALL",
        label: "All (default)",
    },
    {
        id: "Completed",
        label: "Completed PACE",
        icon: "paceIconColored",
    },
    {
        id: "Not Sharing",
        label: "Not Sharing PACE",
        icon: "paceIconNotShared",
    },
    {
        id: "Incomplete",
        label: "Incomplete PACE",
        icon: "paceIconGrayedOut",
    },
];

export const tableHeaderConfig: {
    id: string | number;
    name: string;
    isSortable: boolean;
    isSortableByBestMatch?: boolean;
    isHidden?: boolean;
    sx: React.CSSProperties;
}[] = [
    {
        id: "user",
        name: "User",
        isSortable: true,
        isSortableByBestMatch: true,
        sx: { width: 150 },
    },
    {
        id: "assessment-progress",
        name: "Assessment Progress",
        isSortable: false,
        sx: { width: 160 },
    },
    {
        id: "teams",
        name: "Teams",
        isSortable: false,
        isHidden: false,
        sx: { width: 350 },
    },
    {
        id: "lastContacted",
        name: "Last Contacted",
        isSortable: false,
        isHidden: false,
        sx: { width: 150 },
    },
    {
        id: "actions",
        name: "Actions",
        isSortable: false,
        sx: { width: 120 },
    },
];
